module.exports = __webpack_public_path__ + "assets/CIntersectCLDetailed.60144046e5fa5bbf026e7c35813d3095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CIntersectCLDetailed.png
// module id = 473
// module chunks = 0